export var CombinatorTypes = [ '>', '<', '~', '+' ];
